goog.provide("shadow.js.shim.module$$launchdarkly$observability");
goog.provide("module$shadow_js_shim_module$$launchdarkly$observability");
shadow.js.shim.module$$launchdarkly$observability = shadow.js.nativeProvides["@launchdarkly/observability"] = shadow$bridge("@launchdarkly/observability");
module$shadow_js_shim_module$$launchdarkly$observability.default = shadow.js.shim.module$$launchdarkly$observability;
